import * as React from 'react';
import { useState } from 'react';
import classname from 'classnames';

import UItem from '../item';
import {
  BaseWidgetProps,
  OptionsProps,
} from '../../utils/type';

export interface ValueProps extends BaseWidgetProps {
  value: any;
  className?: string;
  label?: string;
  suffix?: string;
  options?: OptionsProps;
}

const ValueChilds = (props: ValueProps) => {
  const [hide, setHide] = useState(true);
  const {
    prefixCls = 'crm-value-childs',
    value = '',
    suffix,
    options,
  } = props;
  const cls = classname(`${prefixCls}-toggle`, {
    [`${prefixCls}-toggle-hidden`]: hide,
  });

  return (
    <>
      <UItem
        {...props}
        itemType="valueChilds"
      >
        <div className={cls} onClick={() => setHide(!hide)}>
          {value}
          {suffix || ''}
        </div>
      </UItem>
      {
        (!hide && Array.isArray(options) && options.length) && (
          <div className={`${prefixCls}-sub`}>
            {
              options.map((item: any, key: number) => (
                <div className={`${prefixCls}-item`} key={`item_${key}`}>
                  <div className="item-label">{item.label}</div>
                  <div className="item-content">{item.value}{item.suffix || ''}</div>
                </div>
              ))
            }
          </div>
        )
      }
    </>
  );
};

export default ValueChilds;
